import { render, staticRenderFns } from "./viewHpbkDetails.vue?vue&type=template&id=e326489c&scoped=true"
import script from "./viewHpbkDetails.vue?vue&type=script&lang=js"
export * from "./viewHpbkDetails.vue?vue&type=script&lang=js"
import style0 from "./viewHpbkDetails.vue?vue&type=style&index=0&id=e326489c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e326489c",
  null
  
)

export default component.exports